import React from 'react'
import { connect } from 'react-redux'

import { Redirect } from 'react-router-dom'
import { userActions } from '../_actions'
import ReCAPTCHA from 'react-google-recaptcha'

// import 'bootstrap/dist/css/bootstrap.min.css'
// import '../assets/css/bootstrap-rtl.css'
import '../assets/css/login.css'

class LoginPage extends React.Component {
  constructor(props) {
    super(props)

    // reset login status
    this.props.dispatch(userActions.logout())

    this.state = {
      username: '',
      password: '',
      // captcha: false,
      submitted: false
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(e) {
    const { name, value } = e.target
    this.setState({ [name]: value })
  }

  handleSubmit(e) {
    e.preventDefault()

    this.setState({ submitted: true })
    // const { username, password, captcha } = this.state;
    const { username, password } = this.state

    const { dispatch } = this.props
    // if (username && password && captcha) {
    //   dispatch(userActions.login(username, password))
    // }
    if (username && password) {
      dispatch(userActions.login(username, password))
    }
  }

  render() {
    const { loggingIn, loggedIn } = this.props
    // const { username, password, captcha, submitted } = this.state
    const { username, password, submitted } = this.state

    // this is where we get the old route - from the state of the redirect
    const { from } = this.props.location.state || {
      from: { pathname: '/admin' }
    }
    if (loggedIn) {
      return <Redirect to={from} />
    }

    return (
      <div className="container-fluid login-body">
        <div className="login text-center">
          <div className="row flex-row">
            <div className="col-md-6 col-sm-12 col-xs-12">
              <div className="left-panel">
                <img src="/home/logo.png" alt="" />

                <form name="form" onSubmit={this.handleSubmit}>
                  <div className="row">
                    <div className="form-inline">
                      <div className="col-md-12 text-right">
                        <label className="pull-right">نام کاربری</label>
                        <input
                          type="text"
                          className="text-input"
                          autoComplete="off"
                          name="username"
                          defaultValue={username}
                          placeholder="ﻧﺎم ﮐﺎرﺑﺮی ﺧﻮد را وارد ﻧﻤﺎﯾﯿﺪ"
                          onChange={this.handleChange}
                        />
                        {submitted && !username && (
                          <div
                            className={'required_validator visible'}
                            style={{ left: 'auto' }}>
                            <div
                              className="validator_container"
                              style={{ paddingRight: 20, paddingLeft: 20 }}>
                              <span>نام کاربری وارد نشده است</span>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="clearfix" />

                      <div className="col-md-12 text-right">
                        <label className="pull-right">رمز ورود</label>
                        <input
                          type="password"
                          className="text-input"
                          autoComplete="off"
                          name="password"
                          defaultValue={password}
                          placeholder="رﻣﺰ  ورود ﺑﻪ ﺳﺎﻣﺎﻧﻪ را وارد ﻧﻤﺎﯾﯿﺪ"
                          onChange={this.handleChange}
                        />
                        {submitted && !password && (
                          <div
                            className={'required_validator visible'}
                            style={{ left: 'auto' }}>
                            <div
                              className="validator_container"
                              style={{ paddingRight: 20, paddingLeft: 20 }}>
                              <span>رمز ورود وارد نشده است</span>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="clearfix" />

                      {/* <div className="col-md-12 text-right">
                        <label className="pull-right">عبارت امنیتی</label>
                        <ReCAPTCHA
                          name="captcha"
                          // sitekey="6LdAR7IUAAAAAPPz8y3B9OKFenQV81XiVAOBixgx"
                          sitekey="6LeV3swUAAAAAFYTtvUdqNord4LHGMQdumehzkl1"
                          onChange={() => this.setState({ captcha: true })}
                        />
                        {submitted && !captcha &&
                          <div className={"required_validator visible"} style={{ left: 'auto' }}><div className="validator_container" style={{ paddingRight: 20, paddingLeft: 20 }}><span>لطفا عبارت امنیتی را تایید نمائید</span></div></div>}
                      </div> */}

                      <div className="clearfix" />
                      <br />

                      <div className="col-md-12">
                        <button>
                          {loggingIn && (
                            <i className="mdi mdi-spin mdi-loading" />
                          )}
                          &nbsp; ورود به سامانه &nbsp;
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-md-6 col-sm-12 col-xs-12">
              <div className="right-panel">
                <div className="header">
                  <h1>ﺳﺎﻣﺎﻧﻪ آﻣﻮزش اﺻﻨﺎف</h1>
                  <p>
                    ﻫﻤﮑﺎران ﮔﺮاﻣﯽ ﻟﻄﻔﺎ در ﺣﻔﻆ و ﻧﮕﻬﺪاری ﺣﺴﺎب ﮐﺎرﺑﺮی ﺧﻮد دﻗﺖ
                    ﻓﺮﻣﺎﯾﯿﺪ
                    <br />
                    ﻣﺴﺌﻮﻟﯿﺖ ﻧﮕﻬﺪاری از ﻣﺸﺨﺼﺎت ﮐﺎرﺑﺮی ﺑﺮﻋﻬﺪه اﺗﺤﺎدﯾﻪ ﻣﯽ ﺑﺎﺷﺪ
                  </p>
                </div>

                <img src="/login/ex-img.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { loggingIn, loggedIn } = state.authentication
  return {
    loggingIn,
    loggedIn
  }
}

const connectedLoginPage = connect(mapStateToProps)(LoginPage)
export { connectedLoginPage as LoginPage }
